import { createContext } from 'react'

export const ThemeDetect = createContext()
